module.exports = __webpack_public_path__ + "static/media/onss_logo.9a9f3da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/integrations_logos/onss_logo.png
// module id = 301
// module chunks = 0